import { message } from "antd";
import { axiosGet, axiosPatch, axiosPost } from "../axios";

export const getReviews = async ({
  currentPage = 1,
  itemPerPage = 3,
  businessId,
}) => {
  try {
    const res = await axiosGet({
      path: `review/list?businessId=${businessId}&pageNumber=${currentPage}&itemPerPage=${itemPerPage}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const getReview = async (id) => {
  try {
    const res = await axiosGet({
      path: `review/${id}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const addReview = async (payload) => {
  try {
    const res = await axiosPost({
      path: `review`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const updateReview = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `review/${id}`,
      payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const allRatingAverage = async (id) => {
  try {
    const res = await axiosGet({
      path: `review/average?businessId=${id}&isBusiness=${true}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
